import { render, staticRenderFns } from "./rotate-button.vue?vue&type=template&id=5f7a71ee&"
import script from "./rotate-button.vue?vue&type=script&lang=ts&"
export * from "./rotate-button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports